import { ConfigurationT } from 'components/ui-new/customization-configuration-popup/types';
import { useEffect, useMemo, useState } from 'react';

export const filterArray = (str: string, array: ConfigurationT[]): ConfigurationT[] => {
  return array.filter((variant) => variant.name.toLowerCase().includes(str.toLowerCase()));
};

const useCustomizationConfigurationSearch = (sourceArray: ConfigurationT[] = []) => {
  const [searchState, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const filtered = useMemo(() => {
    if (!searchState.trim()) {
      return sourceArray;
    }
    return filterArray(searchState, sourceArray);
  }, [searchState, sourceArray]);

  useEffect(() => {
    setIsLoading(!!searchState);
  }, [searchState]);

  return {
    filtered,
    isLoading,
    searchState,
    setSearch,
  };
};

export default useCustomizationConfigurationSearch;
